import NavbarDesktop from "../Home-Page/Header/NavbarDesktop/NavbarDesktop";
import Footer from "../Home-Page/Footer/Footer";
import ScrollTop from "../Home-Page/Main/ScrollTop/ScrollTop";

function Layout({children}) {
  return (
    <>
      <NavbarDesktop />
      {children}
      <ScrollTop />
      <Footer />
    </>
  );
}

export default Layout;